<template>
  <div class="aw-page">
    <HeadNav selectedLanguage="id" page="home" />
    <main>
      <section class="hero-section">
        <div class="hero-copy">
          <h1>Unduh WA GB APK Versi Terbaru 2026</h1>
          <p class="hero-text">WA GB adalah WhatsApp MOD dengan berbagai fitur tambahan untuk privasi, kustomisasi, dan komunikasi. Download <strong>WA GB APK versi terbaru</strong> dan nikmati fitur-fitur terbaru dengan pengalaman penggunaan yang lebih fleksibel.</p>
          <div class="hero-actions">
            <img class="hero-logo" src="@/assets/wa-gb-logo.webp" alt="Logo WA GB" width="128" height="128">
            <div class="hero-chips" role="group" aria-label="Sorotan unduhan">
              <button class="hero-chip" type="button" @click="download">
                <span class="hero-chip-icon" aria-hidden="true">🎁</span>
                <span class="hero-chip-text">Gratis</span>
              </button>
              <button class="hero-chip" type="button" @click="download">
                <span class="hero-chip-icon" aria-hidden="true">🛡️</span>
                <span class="hero-chip-text">Unduhan Aman</span>
              </button>
              <button class="hero-chip" type="button" @click="download">
                <span class="hero-chip-icon" aria-hidden="true">✓</span>
                <span class="hero-chip-text">Versi Terbaru</span>
              </button>
              <button class="hero-chip" type="button" @click="download">
                <span class="hero-chip-icon" aria-hidden="true">⚡</span>
                <span class="hero-chip-text">Cepat & Mudah</span>
              </button>
            </div>
            <button class="primary-action" type="button" @click="download">
              <svg class="primary-action__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 3v10.7m0 0 4.2-4.2M12 13.7 7.8 9.5M5 17.5V20h14v-2.5" />
              </svg>
              <span>WA_GB_APK_v18.80 Unduh</span>
            </button>
          </div>
        </div>
        <div class="hero-visual">
          <PhoneGallery class="hero-gallery" theme="green" variant="id" />
        </div>
      </section>
      <AlternativesGrid title="Alternatives to GBWhatsApp" :items="alts" />

      <section class="content-section">
        <p><strong>WA GB APK</strong> dibuat untuk pengguna Android yang menginginkan lebih banyak kontrol dibandingkan aplikasi WhatsApp standar. Selain fitur perpesanan dasar, aplikasi ini menyediakan berbagai pengaturan privasi dan tampilan yang dapat disesuaikan.</p>
        <p>WhatsApp GB juga dikenal karena menyediakan fitur seperti menyembunyikan status online, menyembunyikan centang biru, mengunduh status, menggunakan tema khusus, mengunci chat, dan mengirim file dengan ukuran lebih besar.</p>
        <p>Karena WA GB merupakan aplikasi modifikasi, file APK perlu dipasang secara manual di perangkat Android.</p>
      </section>

      <section class="content-section">
        <h2>Detail Pengujian</h2>
        <SimpleTable caption="Detail pengujian WA GB" compact :columns="testCols" :rows="testRows" />
      </section>

      <section class="content-section" aria-label="Hasil Instalasi">
        <div class="result-cards">
          <article v-for="group in installResults" :key="group.title" class="result-card">
            <h3>{{ group.title }}</h3>
            <ul>
              <li
                v-for="item in group.items"
                :key="item.label"
                class="result-item"
                :class="'result-item--' + item.tone"
              >
                <span class="result-item__label">
                  <span class="result-item__icon" aria-hidden="true">{{ item.icon }}</span>
                  {{ item.label }}
                </span>
                <span class="result-item__value">{{ item.value }}</span>
              </li>
            </ul>
          </article>
        </div>
        <p class="note-line">Hasil pengujian dapat berbeda tergantung perangkat, versi Android, akun, dan versi APK yang digunakan.</p>
      </section>

      <section class="content-section">
        <h2>Apa Itu WA GB?</h2>
        <p>WA GB adalah versi modifikasi dari WhatsApp yang dikembangkan dengan berbagai fitur tambahan untuk pengguna Android. Fokus utamanya adalah memberikan lebih banyak pilihan dalam hal privasi, tampilan, pengaturan chat, dan berbagi media.</p>
        <p>Berbeda dari aplikasi WhatsApp standar, <strong>WA GB</strong> menyediakan lebih banyak kontrol terhadap aktivitas online. Pengguna dapat menyembunyikan status online, membekukan Last Seen, menyembunyikan centang biru, dan menonaktifkan indikator mengetik.</p>
        <p>WA GB juga menawarkan berbagai pilihan tema, font, warna, dan tampilan chat. Pengguna yang menyukai personalisasi dapat mengubah tampilan aplikasi sesuai dengan gaya mereka.</p>
        <p>WhatsApp GB tetap mempertahankan tampilan dasar WhatsApp sehingga pengguna tidak perlu mempelajari sistem baru dari awal.</p>
        <p>Karena dikembangkan oleh pengembang independen, WA GB biasanya tersedia dalam bentuk APK dan perlu dipasang secara manual di Android.</p>
      </section>

      <section class="content-section">
        <h2>Mengapa Pengguna Memilih WA GB?</h2>
        <p>Banyak pengguna memilih WA GB karena ingin mendapatkan lebih banyak fitur daripada yang tersedia pada aplikasi WhatsApp biasa.</p>
        <p>Beberapa alasan yang paling umum adalah:</p>
        <ul>
          <li v-for="reason in reasons" :key="reason"><span v-html="reason" /></li>
        </ul>
      </section>

      <section class="content-section">
        <h2>Manfaat Menggunakan WA GB</h2>
        <p>WA GB memberikan lebih banyak pilihan untuk mengatur cara menggunakan aplikasi perpesanan.</p>
        <p>Salah satu manfaat utamanya adalah kontrol privasi. Anda dapat menentukan informasi aktivitas apa yang ingin ditampilkan kepada kontak.</p>
        <p>Fitur seperti menyembunyikan centang biru dan indikator mengetik berguna bagi pengguna yang ingin membaca pesan atau menyiapkan balasan tanpa langsung menunjukkan aktivitas mereka.</p>
        <p>WA GB juga memudahkan pengguna dalam menyimpan media. Foto dan video dari status dapat disimpan langsung ke perangkat tanpa aplikasi tambahan.</p>
        <p>Pilihan tema dan font memberikan lebih banyak kebebasan untuk mengubah tampilan aplikasi. Pengguna dapat membuat tampilan chat menjadi lebih sederhana atau lebih berwarna.</p>
        <p>Fitur berbagi file juga menjadi salah satu alasan WhatsApp GB digunakan. Pengguna dapat mengirim berbagai jenis media dengan batas yang lebih fleksibel dibandingkan aplikasi standar.</p>
      </section>

      <section class="content-section">
        <h2>Fitur Utama WA GB APK</h2>
        <figure class="content-figure">
          <img
            src="@/assets/wa-gb-fitur-utama.webp"
            alt="Fitur utama privasi WA GB"
            width="1483"
            height="827"
            loading="lazy"
          >
        </figure>
        <div class="two-col-cards">
          <article v-for="item in mainFeatures" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </section>

      <section class="content-section">
        <h2>Fitur Kustomisasi WA GB</h2>
        <div class="five-col-cards">
          <article v-for="item in customFeatures" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </section>

      <section class="content-section">
        <h2>Fitur Perpesanan WA GB</h2>
        <div class="balanced-cards">
          <article v-for="item in messageFeatures" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </section>

      <section class="content-section">
        <h2>Perbedaan WA GB dan WhatsApp Standar</h2>
        <SimpleTable caption="Perbedaan WA GB dan WhatsApp standar" :columns="diffCols" :rows="diffRows" />
      </section>

      <section class="content-section">
        <h2>Versi Terbaru WA GB APK – v18.80</h2>
        <p>Versi terbaru yang digunakan dalam pengujian adalah <strong>WA GB v18.80</strong>.</p>
        <p>Versi ini memiliki ukuran sekitar <strong>95 MB</strong> dan ditujukan untuk perangkat Android 5.0 atau lebih tinggi.</p>
        <h3>Informasi WA GB</h3>
        <SimpleTable caption="Informasi WA GB" :columns="infoCols" :rows="infoRows" />
      </section>

      <section class="content-section">
        <h2>Persyaratan Sistem WA GB</h2>
        <p>Sebelum memasang WA GB APK, pastikan perangkat memenuhi persyaratan dasar.</p>
        <SimpleTable caption="Persyaratan sistem WA GB" :columns="reqCols" :rows="reqRows" />
        <p>Sebaiknya sediakan ruang kosong lebih dari ukuran APK karena aplikasi membutuhkan ruang tambahan untuk data, media, cache, dan backup.</p>
      </section>

      <section id="installation-guide" class="content-section">
        <h2>Cara Unduh dan Install WA GB</h2>
        <ol class="install-timeline">
          <li v-for="(step, index) in installSteps" :key="step.title" class="install-timeline__item">
            <div class="install-timeline__marker" aria-hidden="true">{{ index + 1 }}</div>
            <div class="install-timeline__content">
              <strong>{{ step.title }}</strong>
              <p v-html="step.text"></p>
            </div>
          </li>
        </ol>
      </section>

      <section class="content-section">
        <h2>Cara Mengatur Profil di WA GB</h2>
        <ol class="install-timeline">
          <li v-for="(step, index) in profileSteps" :key="step.title" class="install-timeline__item">
            <div class="install-timeline__marker" aria-hidden="true">{{ index + 1 }}</div>
            <div class="install-timeline__content">
              <strong>{{ step.title }}</strong>
              <p>{{ step.text }}</p>
            </div>
          </li>
        </ol>
        <p>Setelah selesai, profil WA GB siap digunakan.</p>
      </section>

      <section class="content-section">
        <h2>Cara Update WA GB ke Versi Terbaru</h2>
        <p>Pembaruan membantu memperbaiki bug dan meningkatkan kompatibilitas aplikasi.</p>
        <div class="two-col-cards">
          <article>
            <h3>Update Manual</h3>
            <ol class="guide-steps">
              <li v-for="(step, index) in manualUpdateSteps" :key="step">
                <span class="guide-steps__num" aria-hidden="true">{{ index + 1 }}</span>
                <span class="guide-steps__text">{{ step }}</span>
              </li>
            </ol>
            <p class="note-line">Jangan menghapus versi lama terlebih dahulu jika Anda ingin mempertahankan data lokal.</p>
          </article>
          <article>
            <h3>Update dari Dalam Aplikasi</h3>
            <p>Jika versi WA GB yang digunakan menyediakan pemeriksaan update:</p>
            <ol class="guide-steps">
              <li v-for="(step, index) in inAppUpdateSteps" :key="step">
                <span class="guide-steps__num" aria-hidden="true">{{ index + 1 }}</span>
                <span class="guide-steps__text" v-html="step"></span>
              </li>
            </ol>
          </article>
        </div>
      </section>

      <section class="content-section">
        <h2>Riwayat Pembaruan WA GB</h2>
        <SimpleTable caption="Riwayat pembaruan WA GB" :columns="historyCols" :rows="historyRows" />
      </section>

      <section class="content-section id-detail-stack">
        <h2>Apa yang Baru di WA GB v18.80?</h2>
        <p>WA GB v18.80 membawa sejumlah perubahan pada privasi, kustomisasi, performa, dan fitur komunikasi.</p>
        <div class="two-col-cards">
          <article v-for="item in whatsNew" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </section>

      <section class="content-section id-detail-stack">
        <h2>Pembaruan Keamanan dan Kontrol</h2>
        <div class="two-col-cards">
          <article v-for="item in securityUpdates" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </section>

      <section class="content-section id-detail-stack">
        <h2>Peningkatan Tambahan</h2>
        <div class="five-col-cards">
          <article v-for="item in extraUpdates" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </section>

      <section class="content-section id-detail-stack">
        <h2>Cara Backup Chat WA GB</h2>
        <p>Backup penting sebelum melakukan update, reinstall, atau berpindah perangkat.</p>
        <ol class="step-list">
          <li>Buka WA GB.</li>
          <li>Tekan menu tiga titik.</li>
          <li>Pilih <strong>Settings</strong>.</li>
          <li>Masuk ke <strong>Chats</strong>.</li>
          <li>Pilih <strong>Chat Backup</strong>.</li>
          <li>Tekan <strong>Backup</strong>.</li>
          <li>Tunggu hingga proses selesai.</li>
        </ol>
        <p>Pastikan ruang penyimpanan cukup selama proses backup.</p>
        <h3>Di Mana Backup WA GB Disimpan?</h3>
        <p>Backup lokal biasanya berada di penyimpanan internal perangkat.</p>
        <p>Folder yang digunakan dapat berbeda tergantung versi aplikasi. Pada beberapa perangkat, backup dapat ditemukan di folder yang berkaitan dengan <strong>GBWhatsApp</strong> atau database aplikasi.</p>
        <p>Sebaiknya jangan menghapus folder backup sebelum memastikan bahwa data sudah berhasil dipindahkan atau dicadangkan.</p>
        <h3>Cara Restore Chat WA GB</h3>
        <ol class="step-list">
          <li>Install WA GB versi yang kompatibel.</li>
          <li>Buka aplikasi.</li>
          <li>Masukkan nomor telepon.</li>
          <li>Selesaikan verifikasi.</li>
          <li>Pastikan file backup tersedia.</li>
          <li>Pilih <strong>Restore</strong> jika pilihan muncul.</li>
          <li>Tunggu proses pemulihan selesai.</li>
        </ol>
        <p>Setelah restore selesai, chat dan media yang tersedia di backup akan muncul kembali.</p>
      </section>

      <section class="content-section id-detail-stack id-tip-stack">
        <h2>Tips Sebelum Update WA GB</h2>
        <p>Buat backup sebelum memasang versi baru.</p>
        <p>Pastikan baterai perangkat cukup dan ruang penyimpanan tersedia.</p>
        <p>Gunakan file APK yang sesuai dengan versi Android Anda.</p>
        <p>Jangan menghapus aplikasi lama sebelum memastikan backup sudah tersimpan.</p>
        <p>Jika instalasi gagal, periksa kembali ruang penyimpanan, kompatibilitas Android, dan file APK yang digunakan.</p>
      </section>

      <FaqList title="FAQ WA GB" :items="faqs" />

      <section class="content-section id-detail-stack">
        <h2>Kesimpulan</h2>
        <p>WA GB menawarkan lebih banyak pilihan dibandingkan WhatsApp standar, terutama dalam hal privasi, tampilan, pengaturan chat, dan berbagi media.</p>
        <p>Namun, karena WA GB merupakan aplikasi modifikasi pihak ketiga, pengguna perlu mempertimbangkan risiko keamanan, kompatibilitas, dan kemungkinan pembatasan akun.</p>
        <p>Sebelum memasang atau memperbarui WA GB APK, buat backup chat terlebih dahulu dan pastikan perangkat memenuhi persyaratan versi aplikasi.</p>
      </section>

      <section class="final-cta">
        <div>
          <h2>Unduh WA GB v18.80</h2>
          <p>Pastikan backup chat sudah dibuat sebelum memasang APK.</p>
        </div>
        <button class="primary-action" type="button" @click="download">Unduh APK</button>
      </section>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/site.scss';
import HeadNav from '@/components/HeadNav.vue';
import AlternativesGrid from '@/components/AlternativesGrid.vue';
import FaqList from '@/components/FaqList.vue';
import SimpleTable from '@/components/SimpleTable.vue';
import PhoneGallery from '@/components/PhoneGallery.vue';
import apkDownload from '@/mixins/apkDownload';
import { getAlternatives } from '@/content/mods';

export default {
  name: 'IdHome',
  components: { HeadNav, AlternativesGrid, FaqList, SimpleTable, PhoneGallery },
  mixins: [apkDownload],
  data() {
    return {
      alts: getAlternatives('gb', 'id'),
      testCols: ['Informasi', 'Hasil'],
      testRows: [
        ['Diuji Oleh', 'Tim Riset'],
        ['Tanggal Pengujian', '01 Agustus 2026'],
        ['Perangkat', 'Infinix Hot 60i'],
        ['Android', 'Android 15'],
        ['Versi APK', 'WA GB v18.80'],
      ],
      installResults: [
        {
          icon: '✅',
          title: 'Hasil Instalasi',
          items: [
            { icon: '📦', label: 'Instalasi APK', value: 'Berhasil', tone: 'ok' },
            { icon: '▶️', label: 'Peluncuran Aplikasi', value: 'Berjalan normal', tone: 'ok' },
            { icon: '🔐', label: 'Verifikasi Akun', value: 'Berhasil', tone: 'ok' },
            { icon: '💬', label: 'Pemulihan Backup Chat', value: 'Berhasil tanpa error', tone: 'ok' },
          ],
        },
        {
          icon: '🛡️',
          title: 'Pemeriksaan Keamanan',
          items: [
            { icon: '📅', label: 'Pemantauan Ban 7 Hari', value: 'Tidak ditemukan ban selama pengujian', tone: 'ok' },
            { icon: '⚠️', label: 'Google Play Protect', value: 'Peringatan dapat muncul karena aplikasi merupakan APK modifikasi', tone: 'warn' },
            { icon: '🔓', label: 'Sumber Tidak Dikenal', value: 'Perlu diaktifkan untuk instalasi manual', tone: 'warn' },
          ],
        },
        {
          icon: '⚡',
          title: 'Performa dan Stabilitas',
          items: [
            { icon: '💨', label: 'Performa', value: 'Lancar selama penggunaan normal', tone: 'ok' },
            { icon: '🖱️', label: 'Respons Antarmuka', value: 'Cepat dan responsif', tone: 'ok' },
            { icon: '🐛', label: 'Bug', value: 'Sedikit keterlambatan saat menerapkan tema berukuran besar', tone: 'warn' },
            { icon: '💥', label: 'Crash', value: 'Tidak ditemukan selama pengujian', tone: 'ok' },
          ],
        },
      ],
      reasons: [
        '<strong>Privasi lebih lengkap:</strong> Sembunyikan Last Seen, online, centang biru, dan status mengetik.',
        '<strong>Tema khusus:</strong> Ubah warna, font, ikon, dan tampilan chat.',
        '<strong>Berbagi file lebih besar:</strong> Mengirim video, gambar, dan dokumen dengan batas yang lebih longgar.',
        '<strong>Anti-delete:</strong> Melihat pesan atau status yang telah dihapus.',
        '<strong>Pengunduh status:</strong> Menyimpan foto dan video dari status kontak.',
        '<strong>Kunci chat:</strong> Melindungi percakapan tertentu dengan PIN atau metode keamanan lain.',
        '<strong>Balasan otomatis:</strong> Mengirim respons otomatis ketika sedang sibuk.',
        '<strong>Penjadwal pesan:</strong> Menyiapkan pesan untuk dikirim pada waktu tertentu.',
        '<strong>Dukungan banyak akun:</strong> Mengelola lebih dari satu akun pada perangkat.',
        '<strong>Kustomisasi chat:</strong> Mengubah tampilan percakapan sesuai keinginan.',
      ],
      mainFeatures: [
        { icon: '❄️', title: 'Bekukan atau Sembunyikan Last Seen', text: 'WA GB memungkinkan pengguna menyembunyikan Last Seen atau membekukan waktu terakhir terlihat. Dengan pengaturan ini, kontak lain tidak selalu dapat melihat aktivitas terbaru Anda.' },
        { icon: '✓', title: 'Sembunyikan Centang Biru', text: 'Fitur ini memungkinkan Anda membaca pesan tanpa langsung menampilkan centang biru kepada pengirim. Anda dapat membaca pesan terlebih dahulu dan membalas ketika sudah siap.' },
        { icon: '⌨️', title: 'Sembunyikan Status Mengetik', text: 'WA GB dapat menyembunyikan indikator ketika Anda sedang mengetik. Kontak tidak akan melihat indikator mengetik saat Anda sedang menyiapkan pesan.' },
        { icon: '🎙️', title: 'Sembunyikan Status Merekam', text: 'Indikator perekaman suara juga dapat disembunyikan sehingga kontak tidak melihat ketika Anda sedang merekam pesan suara.' },
        { icon: '👁️', title: 'Sembunyikan Tampilan Status', text: 'Anda dapat melihat status kontak tanpa menampilkan informasi bahwa status tersebut telah dilihat. Fitur ini cocok bagi pengguna yang ingin melihat status secara lebih pribadi.' },
        { icon: '💬', title: 'Anti-Delete Messages', text: 'Fitur Anti-Delete memungkinkan pesan yang sudah dihapus oleh pengirim tetap terlihat dalam kondisi tertentu. Dengan begitu, pesan yang dihapus tidak langsung menghilang dari percakapan.' },
        { icon: '📷', title: 'Anti-Delete Status', text: 'Selain pesan, fitur ini juga dapat mempertahankan status yang telah dihapus selama status tersebut sudah tersedia di perangkat.' },
        { icon: '↪️', title: 'Sembunyikan Label Forwarded', text: 'WA GB menyediakan pilihan untuk menyembunyikan label "Forwarded" ketika meneruskan pesan.' },
        { icon: '📞', title: 'Kontrol Panggilan', text: 'Anda dapat mengatur siapa yang dapat menghubungi Anda melalui panggilan. Pengaturan dapat digunakan untuk mengurangi panggilan yang tidak diinginkan.' },
        { icon: '🎨', title: 'Kustomisasi Layar Chat', text: 'Tampilan chat dapat diubah menggunakan pilihan gelembung chat, gaya centang, font, warna, dan layout.' },
      ],
      customFeatures: [
        { icon: '🎨', title: 'Tema dan Warna', text: 'WA GB menyediakan berbagai pilihan tema dan warna untuk mengubah tampilan aplikasi. Anda dapat menggunakan tema yang tersedia atau memilih tampilan sesuai preferensi.' },
        { icon: '🔤', title: 'Font dan Ukuran Teks', text: 'Pengguna dapat mengubah jenis dan ukuran font untuk membuat tampilan chat lebih nyaman.' },
        { icon: '😀', title: 'Emoji Tambahan', text: 'WhatsApp GB menyediakan pilihan emoji tambahan untuk membuat percakapan lebih ekspresif.' },
        { icon: '🧩', title: 'Stiker', text: 'Anda dapat menggunakan berbagai paket stiker dalam percakapan dan menambahkan stiker yang sesuai dengan kebutuhan.' },
        { icon: '✓', title: 'Gaya Centang', text: 'WA GB menyediakan beberapa pilihan gaya centang sehingga tampilan pesan dapat dibuat berbeda dari WhatsApp standar.' },
      ],
      messageFeatures: [
        { icon: '🤖', title: 'Auto Reply', text: 'Fitur Auto Reply memungkinkan aplikasi mengirim balasan secara otomatis. Anda dapat membuat pesan tertentu untuk digunakan ketika sedang sibuk atau tidak dapat membalas.' },
        { icon: '🗓️', title: 'Message Scheduler', text: 'Message Scheduler memungkinkan Anda menjadwalkan pesan untuk dikirim pada waktu tertentu. Fitur ini dapat digunakan untuk pengingat, ucapan ulang tahun, atau pesan penting lainnya.' },
        { icon: '🌐', title: 'Terjemahan Pesan', text: 'Fitur terjemahan membantu pengguna memahami pesan dalam bahasa berbeda tanpa harus berpindah ke aplikasi lain.' },
        { icon: '🌙', title: 'Mode DND', text: 'Mode Do Not Disturb dapat digunakan untuk menghentikan notifikasi sementara. Fitur ini berguna ketika Anda sedang bekerja, belajar, atau beristirahat.' },
        { icon: '⬇️', title: 'Status Downloader', text: 'WA GB menyediakan pilihan untuk menyimpan foto dan video dari status kontak langsung ke perangkat.' },
        { icon: '📦', title: 'Berbagi File Berukuran Besar', text: 'WA GB mendukung pengiriman file dengan ukuran yang lebih besar dibandingkan batas tertentu pada WhatsApp standar. Fitur ini berguna untuk mengirim video, gambar berkualitas tinggi, dan dokumen.' },
        { icon: '👥', title: 'Banyak Akun', text: 'WA GB dapat digunakan untuk mengelola lebih dari satu akun pada perangkat yang sama, tergantung versi dan dukungan perangkat.' },
      ],
      diffCols: ['Fitur', 'WA GB', 'WhatsApp Standar'],
      diffRows: [
        ['Kustomisasi Lanjutan', 'Ya', 'Terbatas'],
        ['Sembunyikan Online', 'Ya', 'Terbatas'],
        ['Sembunyikan Mengetik', 'Ya', 'Terbatas'],
        ['Anti-Delete', 'Ya', 'Tidak'],
        ['Download Status', 'Ya', 'Terbatas'],
        ['Tema Kustom', 'Ya', 'Terbatas'],
        ['Auto Reply', 'Ya', 'Terbatas'],
        ['Message Scheduler', 'Ya', 'Tidak'],
        ['Kunci Chat', 'Ya', 'Ya'],
        ['Dukungan Resmi', 'Tidak', 'Ya'],
      ],
      infoCols: ['Informasi', 'Detail'],
      infoRows: [
        ['Nama', 'WA GB APK'],
        ['Versi', 'v18.80'],
        ['Pembaruan', 'Agustus 2026'],
        ['Ukuran', '95,0 MB'],
        ['Android', '5.0+'],
        ['Lisensi', 'Gratis'],
        ['Format', 'APK'],
        ['Kualitas Media', 'HD'],
      ],
      reqCols: ['Persyaratan', 'Detail'],
      reqRows: [
        ['Aplikasi', 'WA GB APK'],
        ['Versi', 'v18.80'],
        ['Android', '5.0 atau lebih tinggi'],
        ['Penyimpanan', 'Minimal 100 MB kosong'],
        ['Internet', 'Diperlukan'],
        ['Instalasi', 'Manual APK'],
      ],
      historyCols: ['Tahun', 'Perkembangan'],
      historyRows: [
        ['2026', 'Peningkatan privasi, performa, dan fitur perpesanan'],
        ['2025', 'Perbaikan tampilan dan berbagai fitur tambahan'],
        ['2024', 'Lebih banyak tema dan pilihan kustomisasi'],
        ['2023', 'Peningkatan fitur status dan berbagi media'],
        ['2022', 'Perbaikan bug dan stabilitas'],
        ['2021', 'Optimalisasi performa dan antarmuka'],
        ['2020', 'Peningkatan sistem perlindungan akun'],
        ['2019', 'Pengembangan fitur privasi tambahan'],
        ['2018', 'Fitur kustomisasi mulai semakin populer'],
      ],
      whatsNew: [
        { icon: '🔒', title: 'Kontrol Privasi Lebih Lengkap', text: 'Pengguna memiliki lebih banyak pilihan untuk mengatur status online, Last Seen, centang biru, dan indikator mengetik.' },
        { icon: '👥', title: 'Dukungan Banyak Akun', text: 'Pengguna dapat mengelola beberapa akun pada satu perangkat jika fitur tersebut didukung oleh versi yang digunakan.' },
        { icon: '🔏', title: 'Perlindungan Chat', text: 'Chat tertentu dapat dilindungi menggunakan fitur kunci yang tersedia di aplikasi.' },
        { icon: '⚡', title: 'Performa Lebih Lancar', text: 'Optimalisasi memori dan cache membantu aplikasi bekerja lebih responsif pada penggunaan sehari-hari.' },
        { icon: '📦', title: 'Berbagi Media Lebih Baik', text: 'Pengiriman gambar, video, dokumen, dan pesan suara dibuat lebih praktis.' },
        { icon: '🧭', title: 'Navigasi Lebih Responsif', text: 'Tampilan menu dan perpindahan antarhalaman terasa lebih ringan pada perangkat yang kompatibel.' },
      ],
      securityUpdates: [
        { icon: '🔐', title: 'Keamanan Chat', text: 'Pengguna dapat menggunakan fitur penguncian untuk melindungi percakapan tertentu.' },
        { icon: '💾', title: 'Backup Lebih Fleksibel', text: 'Pilihan backup membantu pengguna menjaga chat dan media sebelum melakukan update atau instalasi ulang.' },
        { icon: '🧹', title: 'Filter Pesan', text: 'Pengaturan filter dapat membantu mengelola pesan yang tidak diinginkan.' },
        { icon: '🔔', title: 'Kontrol Notifikasi', text: 'Pengguna dapat membisukan chat atau grup tertentu agar tidak terus menerima notifikasi.' },
      ],
      extraUpdates: [
        { icon: '✏️', title: 'Edit Pesan', text: 'Pesan yang sudah dikirim dapat diedit selama masih berada dalam batas waktu yang didukung versi aplikasi.' },
        { icon: '📌', title: 'Pin Chat', text: 'Chat penting dapat disematkan agar lebih mudah ditemukan.' },
        { icon: '🔍', title: 'Pencarian Chat', text: 'Fitur pencarian membantu menemukan pesan atau percakapan tertentu dengan lebih cepat.' },
        { icon: '🌐', title: 'Terjemahan', text: 'Alat terjemahan membantu pengguna berkomunikasi dengan orang yang menggunakan bahasa berbeda.' },
        { icon: '🛠️', title: 'Perbaikan Bug', text: 'Pembaruan juga mencakup berbagai perbaikan bug dan peningkatan stabilitas.' },
      ],
      manualUpdateSteps: [
        'Periksa apakah tersedia versi WA GB terbaru.',
        'Download APK versi terbaru.',
        'Pastikan backup chat sudah dibuat.',
        'Install APK baru di atas versi lama.',
        'Tunggu sampai proses update selesai.',
        'Buka WA GB dan periksa chat serta pengaturan.',
      ],
      inAppUpdateSteps: [
        'Buka WA GB.',
        'Masuk ke <strong>GB Settings</strong>.',
        'Pilih <strong>Updates</strong>.',
        'Periksa versi terbaru.',
        'Ikuti instruksi pembaruan.',
      ],
      installSteps: [
        {
          title: 'Unduh WA GB APK',
          text: 'Unduh file WA GB APK versi yang sesuai dengan perangkat Android Anda. Setelah download selesai, buka folder <strong>unduh</strong> menggunakan File Manager.',
        },
        {
          title: 'Aktifkan Sumber Tidak Dikenal',
          text: 'Android mungkin memblokir instalasi APK dari luar Play Store. Buka <strong>Pengaturan → Keamanan → Instal Aplikasi Tidak Dikenal</strong>. Pilih browser atau File Manager yang digunakan untuk membuka APK, lalu izinkan instalasi.',
        },
        {
          title: 'Install WA GB',
          text: 'Buka file APK yang telah diunduh. Tekan <strong>Install</strong> dan tunggu sampai proses selesai. Setelah instalasi selesai, buka WA GB.',
        },
        {
          title: 'Verifikasi Nomor',
          text: 'Masukkan nomor telepon yang ingin digunakan. Ikuti proses verifikasi dan masukkan kode OTP yang diterima.',
        },
        {
          title: 'Pulihkan Chat',
          text: 'Jika tersedia backup, pilih opsi <strong>Restore</strong> untuk memulihkan chat dan media. Sebaiknya buat backup sebelum mengganti atau memperbarui aplikasi.',
        },
      ],
      profileSteps: [
        { title: 'Buka WA GB', text: 'Jalankan aplikasi setelah instalasi selesai.' },
        { title: 'Pilih Bahasa', text: 'Pilih bahasa yang ingin digunakan.' },
        { title: 'Masukkan Nomor Telepon', text: 'Masukkan nomor telepon dan selesaikan verifikasi.' },
        { title: 'Pulihkan Backup', text: 'Jika backup tersedia, pilih Restore untuk mengembalikan chat.' },
        { title: 'Tambahkan Nama', text: 'Masukkan nama yang ingin ditampilkan kepada kontak.' },
        { title: 'Tambahkan Foto Profil', text: 'Pilih gambar dari galeri atau ambil foto baru menggunakan kamera.' },
      ],
      faqs: [
        { question: 'Apa itu WA GB?', answer: 'WA GB adalah versi modifikasi WhatsApp dengan tambahan fitur privasi, kustomisasi, dan perpesanan.' },
        { question: 'Apakah WA GB gratis?', answer: 'WA GB biasanya tersedia sebagai APK yang dapat diunduh dan dipasang secara gratis.' },
        { question: 'Apakah WA GB bisa digunakan di Android?', answer: 'Ya. WA GB ditujukan untuk perangkat Android yang memenuhi persyaratan versi aplikasi.' },
        { question: 'Apa versi terbaru WA GB?', answer: 'Versi yang digunakan dalam panduan ini adalah <strong>WA GB v18.80</strong>.' },
        { question: 'Apakah WhatsApp GB sama dengan WA GB?', answer: 'WhatsApp GB dan WA GB biasanya digunakan untuk merujuk pada aplikasi WhatsApp MOD yang sama atau jenis aplikasi modifikasi yang serupa.' },
        { question: 'Apakah WA GB bisa menyembunyikan Last Seen?', answer: 'Ya. WA GB menyediakan pengaturan untuk menyembunyikan atau membekukan Last Seen.' },
        { question: 'Apakah WA GB bisa menyembunyikan centang biru?', answer: 'Ya. Anda dapat menggunakan pengaturan privasi untuk menyembunyikan read receipts.' },
        { question: 'Apakah WA GB bisa mengunduh status?', answer: 'Ya. WA GB menyediakan fitur untuk menyimpan foto dan video dari status kontak.' },
        { question: 'Apakah WA GB bisa mengunci chat?', answer: 'Ya. Versi tertentu menyediakan fitur untuk mengunci chat menggunakan metode keamanan yang tersedia.' },
        { question: 'Bagaimana cara update WA GB?', answer: 'Download APK versi terbaru dan install di atas versi lama setelah membuat backup chat.' },
        { question: 'Apakah chat akan hilang saat update WA GB?', answer: 'Biasanya tidak jika APK baru dipasang di atas versi lama. Namun, backup tetap disarankan sebelum melakukan update.' },
        { question: 'Mengapa WA GB tidak bisa diinstal?', answer: 'Penyebabnya dapat berupa ruang penyimpanan yang kurang, versi Android tidak kompatibel, izin instalasi APK belum diberikan, atau file APK bermasalah.' },
        { question: 'Mengapa WA GB berhenti atau crash?', answer: 'Coba restart perangkat, kosongkan cache, periksa ruang penyimpanan, atau gunakan versi APK yang kompatibel dengan perangkat.' },
        { question: 'Apakah WA GB tersedia di Google Play Store?', answer: 'WA GB merupakan aplikasi modifikasi dan umumnya tidak tersedia melalui Google Play Store.' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.hero-chips {
	gap: 0;
	padding: 4px;
	border: 1px solid #d7e7df;
	border-radius: 10px;
	background: #fff;
	box-shadow: 0 6px 14px rgba(15, 23, 42, 0.05);
}

.hero-chip {
	display: inline-flex;
	flex: 1 1 0;
	align-items: center;
	justify-content: center;
	gap: 6px;
	min-width: 0;
	min-height: 36px;
	padding: 7px 10px;
	border: 0;
	border-right: 1px solid #dfe9e3;
	background: transparent;
	color: #38514a;
	font-family: inherit;
	font-size: 15px;
	font-weight: 600;
	line-height: 1.25;
	letter-spacing: 0;
	white-space: nowrap;
	cursor: pointer;
	transition: background-color 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.hero-chip:last-child {
	border-right: 0;
}

.hero-chip:hover {
	background: #edf8f2;
	color: #0b7a5a;
}

.hero-chip:active {
	transform: translateY(1px);
}

.hero-chip:focus-visible {
	outline: 2px solid rgba(11, 122, 90, 0.5);
	outline-offset: 2px;
}

.hero-chip .hero-chip-icon {
	font-size: 15px;
	line-height: 1;
	font-weight: 400;
}

.hero-chip .hero-chip-text {
	line-height: 1.25;
}

.id-detail-stack {
	.two-col-cards {
		gap: 16px;
	}

	.two-col-cards article {
		padding: 24px;
		border-color: #d8e7df;
		background:
			radial-gradient(ellipse 80% 55% at 100% 0%, rgba(37, 211, 102, 0.07), transparent 55%),
			#fff;
		box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
		transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
	}

	.two-col-cards article:hover {
		border-color: #bcd8ca;
		box-shadow: 0 12px 24px rgba(11, 122, 90, 0.08);
		transform: translateY(-1px);
	}

	.two-col-cards h3 {
		position: relative;
		margin: 0 0 12px;
		padding-left: 18px;
		color: #18231f;
		font-family: var(--aw-font-heading);
		font-size: 21px;
		font-weight: 600;
		line-height: 1.3;
	}

	.two-col-cards h3::before {
		content: "";
		position: absolute;
		top: 0.55em;
		left: 0;
		width: 8px;
		height: 8px;
		margin-top: -4px;
		border-radius: 50%;
		background: #0b7a5a;
	}

	.two-col-cards h3:has(.feature-card-icon) {
		padding-left: 0;
	}

	.two-col-cards h3:has(.feature-card-icon)::before {
		display: none;
	}

	.two-col-cards article > p {
		margin: 0;
		color: #5c6a64;
		font-size: 15px;
		line-height: 1.6;
	}

	> h3 {
		margin-top: 28px;
		font-size: 22px;
		font-weight: 500;
	}

	.step-list {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
		margin: 18px 0 4px;
		padding: 0;
		list-style: none !important;
		list-style-type: none !important;
		counter-reset: detail-step;
	}

	.step-list li {
		position: relative;
		display: flex;
		align-items: flex-start;
		gap: 12px;
		min-height: 54px;
		margin: 0;
		padding: 14px 16px 14px 52px;
		border: 1px solid #e2ece6;
		border-radius: 10px;
		background: #fff;
		color: #4a5550;
		font-size: 15px;
		line-height: 1.5;
		counter-increment: detail-step;
	}

	.step-list li::before {
		content: counter(detail-step);
		position: absolute;
		top: 14px;
		left: 14px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 28px;
		border-radius: 50%;
		background: #e8f6ef;
		color: #0b7a5a;
		font-family: var(--aw-font-heading);
		font-size: 13px;
		font-weight: 600;
		line-height: 1;
	}

	.step-list strong {
		color: #18231f;
	}

	> p {
		color: #5c6a64;
	}
}

.id-tip-stack {
	padding: 24px;
	border: 1px solid #dce5df;
	border-radius: 14px;
	background: linear-gradient(180deg, #fff 0%, #f8fcfa 100%);
	box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.id-tip-stack h2 {
	margin-bottom: 16px;
}

.id-tip-stack p {
	position: relative;
	margin: 0 0 10px;
	padding-left: 20px;
	color: #5c6a64;
	font-size: 16px;
	line-height: 1.6;
}

.id-tip-stack p:last-child {
	margin-bottom: 0;
}

.id-tip-stack p::before {
	content: "";
	position: absolute;
	top: 0.72em;
	left: 0;
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background: #0b7a5a;
}

@media (max-width: 680px) {
	.id-detail-stack .step-list {
		grid-template-columns: 1fr;
	}

	.id-detail-stack .two-col-cards article,
	.id-tip-stack {
		padding: 18px;
	}
}

@media (max-width: 520px) {
	.hero-chips {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		padding: 3px;
	}

	.hero-chip {
		min-height: 38px;
		padding: 8px 6px;
		white-space: normal;
		text-align: center;
	}

	.hero-chip:nth-child(odd) {
		border-right: 1px solid #dfe9e3;
	}

	.hero-chip:nth-child(even) {
		border-right: 0;
	}

	.hero-chip:nth-child(n + 3) {
		border-top: 1px solid #dfe9e3;
	}
}
</style>
